import { Effect, Reducer } from 'umi';
import { gameInfoType } from '../../types/common';
import { initBuriedPoint } from '../../operationLog/buriedPoint';
const usersService = {
  fetch: () => Promise.resolve({ data: [] }),
};

const namespace = 'opinionCommon';
initBuriedPoint();

type stateType = {
  // 游戏参数信息，只有edition_unified_id, entity_type, id_type
  gameInfo: gameInfoType;
  // 展示游戏的数据,该数据不一定准确，只作为游戏名称和图标展示，所以以wholeGameInfo数据为主
  showGameInfo?: gameInfoType;
  // 游戏所有信息
  wholeGameInfo: gameInfoType;
  // 改变游戏的时候设置为false
  changeGameVisible: boolean;
  listMenu: Array<any>;
  pageLoading: boolean;
  gameInfoLoading: boolean;
  listMenuLoading: boolean;
  excludeSource: Array<{ source: string; menu_id: string }>;
  hidePageIds: Array<string>; 
  hideGameListMenu: boolean;
};

const customModel: {
  effects: {
    fetch: Effect;
  };
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    gameInfo: { edition_unified_id: '', entity_type: '', id_type: '' },
    showGameInfo: { edition_unified_id: '', entity_type: '', id_type: '' },
    listMenu: [],
    listMenuLoading: true,
    excludeSource: [],
    hidePageIds: [],
    wholeGameInfo: { edition_unified_id: '', entity_type: '', id_type: '' },
    changeGameVisible: false,
    pageLoading: false,
    gameInfoLoading: true, 
    hideGameListMenu: false,
  },
  reducers: {
    save(state: stateType, { payload }) {
      const { wholeGameInfo } = payload;
      if (wholeGameInfo) {
        const { edition_unified_id, entity_type, id_type } = wholeGameInfo;
        if (edition_unified_id) {
          localStorage.setItem(
            'OpinionGameInfo',
            JSON.stringify(wholeGameInfo),
          );
        }
      }
      return { ...state, ...payload };
    },
  },
  effects: {
    *fetch({ payload }, { put }) {
      const { data } = yield usersService.fetch();
      yield put({
        type: 'save',
        payload: {
          data,
        },
      });
    },
  },
};

export default customModel;
